import React, { useState, useEffect } from "react";

function Dominance() {
  const [domBtc, setDomBtc] = useState(0);
  const [domEth, setDomEth] = useState(0);
  const [domOthers, setDomOthers] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("stats/dominance")
      .then((resp) => resp.json())
      .then((data) => {
        setDomBtc(data.btc);
        setDomEth(data.eth);
        setDomOthers(data.others);
        setLoading(false);
      })
      .catch((err) => console.log(err.message));
  }, []);

  // read any global variable from window.
  window.google.charts.load("current", { packages: ["corechart"] });
  window.google.charts.setOnLoadCallback(() =>
    drawChart(domBtc, domEth, domOthers)
  );

  return (
    <div className="mbox">
      <h4 className="text-center" title="Bitcoin Dominance refers to the percentage of the total cryptocurrency market capitalization that is represented by Bitcoin. It is a key indicator of Bitcoin's market strength relative to other cryptocurrencies.">
        <i className="bi bi-pie-chart-fill" style={{ color: "darkcyan" }}></i>{" "}
        Bitcoin Dominance
      </h4>
      {loading ? (
        <div
          style={{ color: "green", fontStyle: "italic" }}
          className="h5 text-center"
        >
          Loading...
        </div>
      ) : (
        <div style={{ color: "green" }} className="h5 text-center">
          BTC: {domBtc}%
        </div>
      )}
      <div
        id="domChart"
        style={{ width: 300, height: 200, marginLeft: 10, marginTop: 20 }}
      ></div>
      <div style={{ fontSize: 11 }} className="mt-3">
          <span className="p-2">source: coinpaprika</span>
      </div>
    </div>
  );
}

function drawChart(domBtc, domEth, domOthers) {
  const google = window.google;

  var data = google.visualization.arrayToDataTable([
    ["Coin", "Dominance"],
    ["BTC", domBtc],
    //["ETH", domEth],
    ["Others", domOthers],
  ]);

  var options = {
    legend: "none",
    pieSliceText: "label",
    pieStartAngle: 180,
    chartArea: { width: 280, height: 280 },
  };

  var chart = new google.visualization.PieChart(
    document.getElementById("domChart")
  );

  chart.draw(data, options);
}

export default Dominance;
